import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const HintContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  line-height: 21px;
  padding: 4px 16px 24px 16px;
`

export const HintTextBlock = styled.div`
  margin-bottom: 17px;
`

export const HintText = styled.div`
  font-weight: 400;
  color: ${colors.mainText};
`
